import React from 'react';
import {
  Goal,
  GoalLifeAreaLinkChange,
  GoalParentLinkChange,
  UpdateGoal,
} from 'shared/types/goal';
import { ID } from 'shared/types/id';

export enum ContextMenuOptions {
  Archive = 'archive',
  Delete = 'delete',
  ShowRoadmap = 'showRoadmap',
}

export type GroupingGoalListProps = {
  goals: Goal[];
  // Per-parent child order; without it children keep the list order.
  goalChildrenByParentId?: Map<ID, ID[]>;
  collapsedGoals?: ID[];
  onGoalCollapse?: (ids: ID[]) => void;
  scrollElement?: React.RefObject<HTMLDivElement>;
  onReorder?: (
    updatedSections: { id: ID; goalSorting: ID[] }[],
    updatedGoals: UpdateGoal[],
    goalLinkChanges?: GoalLifeAreaLinkChange[],
    goalParentChanges?: GoalParentLinkChange[],
  ) => void;
  onUpdateProgress: (id: string) => void;
  hideLifeArea?: boolean;
  hideArchived?: boolean;
  hideCompleted?: boolean;
  // The link a root row hangs under; a detail page's list is rooted in its own goal or area.
  rootLink?: { goalId?: ID; lifeAreaId?: ID };
  showParentGoalLabel?: boolean;
  showParentLifeAreaLabel?: boolean;
  // Off (projects only by default): plain goals show their parents too — the flat deadline list.
  showParentLabelsForGoals?: boolean;
  // Deadline grouping only: off lists every goal in its own quarter.
  nestSubGoals?: boolean;
  // Goal grouping only: sections are root goals, sub-goals nest as folders down to their projects.
  nestGoals?: boolean;
  isProjectList?: boolean;
  isMultiSelectModifierPressed?: boolean;
  excludedContextMenuOptions?: ContextMenuOptions[];
};
